/**
 * Implements a Behavior to enable analytics tracking on non-routable views.
 */

import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import PageviewModel from "../models/analytics/pageview";

const channel = Radio.channel("global");

class Analytics extends Marionette.Behavior {
  defaults() {
    return {
      opts: {
        fireOnRender: true,
        title: null,
        location: location.href,
        page: null,
      },
    };
  }

  initialize() {
    // merge defaults and user options
    _.defaults(this.options.opts, this.defaults.opts);

    this.model = new PageviewModel({
      title: this.options.opts.title,
      location: this.options.opts.location,
      page: this.options.opts.page,
    });
  }

  onRender() {
    if (this.options.opts.fireOnRender) {
      this.onActivation();
    }
  }

  // custom event used by views that choose to not fire this event on render
  onActivation() {
    this.model.isValid() && channel.request("analytics:pageview", this.model);
  }
}

export { Analytics as default };
